import { getCookie } from 'utils/cookies';
import { allowCookies, optimizelySDKKey } from 'utils/settings';
import { Wrapper } from './types';

let wrapper: Wrapper | undefined = undefined;
const decisionCache: Record<string, ReturnType<Wrapper['decide']>> = {};

const getAttributes = () => {
    return {
        market: window?.location?.pathname?.split('/')?.[1].toUpperCase() || '',
        isLoggedIn: !!getCookie('idp_reguser') || false,
    };
};

export const initializeOptimizely = async () => {
    if (!optimizelySDKKey || optimizelySDKKey === '') {
        return;
    }

    if (window.location.hostname === 'localhost' || allowCookies()) {
        try {
            wrapper =
                wrapper ??
                (await window.ikea.experiment.init(optimizelySDKKey, {
                    timeout: Infinity,
                }));
        } catch (error) {
            // Fail silently.
        }
    } else {
        wrapper = undefined;
    }
};

export const trackEvent = (
    eventKey: string,
    tags: { [key: string]: string | number | boolean } = {}
) => {
    try {
        wrapper?.track(eventKey, getAttributes(), tags);
    } catch {
        // Fail silently.
    }
};

export const decide = (decisionKey: string) => {
    try {
        const cached = decisionCache[decisionKey];
        if (cached) {
            return cached;
        }
        const decision = wrapper?.decide?.(decisionKey);
        if (decision) {
            decisionCache[decisionKey] = decision;
        }
        return decision;
    } catch {
        // Fail silently.
    }
};

export const isExperimentOn = (experimentKey: string): boolean => {
    try {
        return decide(experimentKey)?.variationKey === 'on';
    } catch {
        return false;
    }
};
